import API from '../../sunwiseAPI';
const ENTITY = 'complements-reporter';

export const getComplements = (reportId) =>
    API.get(`/api/v1/${ENTITY}/${reportId}/sunpay`);

export const updateComplements = (reportId, data) =>
    API.put(`/api/v1/${ENTITY}/${reportId}/sunpay`, data);
